import React, { useEffect, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress } from "@mui/material";
import { forecastParameterService } from "../../utils/services/forecast-parameter.service";
import ForecastParameterModal from "../../components/forecastParameterModal";
import ForecastParameterList from "../../components/forecastParameterList";
import { toast } from "react-toastify";

const ForecastParameter = () => {
  const [selectedParameter, setSelectedParameter] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [parameterList, setParameterList] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [searchValue, setSearchValue] = useState("");
  const [clientFilter, setClientFilter] = useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);

  const fetchParameter = async () => {
    setLoading(true);
    try {
      const skip = page * rowsPerPage;
      const response = await forecastParameterService.fetch(
        rowsPerPage,
        skip,
        searchValue
      );
      setParameterList(response?.data);
      setLoading(false);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchParameter();
  }, [page, rowsPerPage, clientFilter, searchValue]);

  const handleExposeToClientClick = async (parameter) => {
    setSelectedParameter(parameter);
    await forecastParameterService.edit(parameter._id, {
      exposed_to_clients: !parameter.exposed_to_clients,
    });
    toast.success(
      `Forecast parameter ${
        parameter.exposed_to_clients ? "hidden from" : "exposed to"
      } clients successfully!`
    );
    setParameterList((prevData) =>
      prevData.map((item) =>
        item._id === parameter._id
          ? { ...item, exposed_to_clients: !item.exposed_to_clients }
          : item
      )
    );
  };

  return (
    <>
      <DashboardContainer
        header={"Forecast Parameter List"}
        hideUploadButton
        title={"+ Add Parameter"}
        onClickAddButton={() => setOpenModal(true)}
        setViewMode={setViewMode}
        onSearchData={(x) => {
          if (x.trim()) {
            setSearchValue(x);
            setPage(0);
          } else {
            setSearchValue("");
          }
        }}
        hideFilterClient
        filterButton={false}
        onClickRefresh={() => fetchParameter()}
      >
        <ForecastParameterModal
          selectedParameter={selectedParameter}
          handleClose={() => {
            setOpenModal(false);
            setSelectedParameter(null);
          }}
          open={openModal}
          onAddData={fetchParameter}
        />
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <ForecastParameterList
            dataCount={dataCount}
            page={page}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            onDeleteData={fetchParameter}
            onEditData={(e) => {
              setSelectedParameter(e);
              setOpenModal(true);
            }}
            data={parameterList}
            viewMode={viewMode}
            selectedParameter={selectedParameter}
            setSelectedParameter={setSelectedParameter}
            handleExposeToClientClick={handleExposeToClientClick}
          />
        )}
      </DashboardContainer>
    </>
  );
};

export default ForecastParameter;
